import * as React from 'react';

import { addModifiers } from '../../shared/helpers';

import './Panel.scss';

interface PanelLinks {
  url: string | undefined;
  label: string | undefined;
  icon?: boolean;
  color?: string;
}

interface PanelProps {
  title?: string;
  children: JSX.Element[] | JSX.Element;
  rightElem?: JSX.Element[] | JSX.Element | null;
  hasHeader?: boolean;
  modifiers?: string[];
  titleModifiers?: string[];
  panelModifiers?: string[];
  firstLink?: PanelLinks;
  nextLink?: PanelLinks;
  handleLink?: () => void;
  label?: string;
  onClickHeader?: () => void;
  path?: string;
}

const Header = ({ title, titleModifiers, rightElem }: any) => (
  <header className="panel__header">
    {title && <h2 className={addModifiers('panel__header-title', titleModifiers)}>{title}</h2>}
    {rightElem && <div>{rightElem}</div>}
  </header>
);

const Footer = (_: any) => <footer className="panel__footer" />;

export const HOCPanel =
  (HeaderComponent = Header, FooterComponent = Footer) =>
  ({
    children,
    title,
    rightElem,
    modifiers = [],
    titleModifiers = [],
    panelModifiers = [],
    hasHeader = true,
    firstLink,
    nextLink,
    handleLink,
    label,
    onClickHeader,
    path = 'learn',
  }: PanelProps): JSX.Element => {
    const modifiedFirstLink =
      titleModifiers && titleModifiers.includes('tutorial-concepts')
        ? { url: `/${path}/documentation`, label: 'Documentation' }
        : firstLink;

    return (
      <article onClick={handleLink} className={addModifiers('panel', panelModifiers)}>
        {hasHeader && (
          <HeaderComponent
            title={title}
            titleModifiers={titleModifiers}
            rightElem={rightElem}
            firstLink={modifiedFirstLink}
            nextLink={nextLink}
            label={label}
            onClick={onClickHeader}
          />
        )}
        <div className={addModifiers('panel__content', modifiers)}>{children}</div>
        {FooterComponent && (
          <FooterComponent title={title} titleModifiers={titleModifiers} rightElem={rightElem} firstLink={firstLink} nextLink={nextLink} />
        )}
      </article>
    );
  };
